import { useEffect } from 'react';

export function useBeforeUnload(enabled: boolean = true) {
  useEffect(() => {
    if (!enabled) return;

    const controller = new AbortController();
    const handler = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      return (event.returnValue = '');
    };
    window.addEventListener('beforeunload', handler, {
      signal: controller.signal,
      capture: true,
    });
    return () => controller.abort();
  }, [enabled]);
}
